"use strict";
var __setFunctionName = (this && this.__setFunctionName) || function (f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.CurrencyHelpers = void 0;
const web_ui_framework_1 = require("@gruposantander/web-ui-framework");
exports.CurrencyHelpers = (_a = class {
    },
    __setFunctionName(_a, "CurrencyHelpers"),
    _a.formatCurrency = (amount, currency, locale = web_ui_framework_1.locale.getLocale()) => {
        const formattedAmount = new Intl.NumberFormat(locale, { style: 'currency', currency }).format(Math.abs(amount));
        return amount < 0 ? `\u2212${formattedAmount}` : formattedAmount;
    },
    _a.getCurrencySymbol = (currencyCode, locale = web_ui_framework_1.locale.getLocale()) => {
        return (new Intl.NumberFormat(locale, { style: 'currency', currency: currencyCode }).formatToParts(1).find(part => part.type === 'currency')
            ?.value || '');
    },
    _a);
//# sourceMappingURL=CurrencyHelpers.js.map